import { Content, Header, Page } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ProductDashboardPage } from '../ReleaseAssistantNative/pages/ProductDashboardPage';
import { ProductDeliveryPage } from '../ReleaseAssistantNative/pages/ProductDeliveryPage';
import { ReleasePage } from '../ReleaseAssistantNative/pages/ReleasePage';
import { ReportsPage } from '../ReleaseAssistantNative/pages/ReportsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const ReleaseAssistantPage = () => {
  const configApi = useApi(configApiRef);
  const location = useLocation();
  const navigate = useNavigate();
  const deliveryEnabled =
    configApi.getOptionalBoolean('releaseAssistant.enableDeliveryScaffolding') ??
    true;

  let currentTab = 'release';
  if (location.pathname.includes('/reports')) {
    currentTab = 'reports';
  } else if (location.pathname.includes('/product-dashboard')) {
    currentTab = 'product-dashboard';
  } else if (location.pathname.includes('/product-delivery')) {
    currentTab = 'product-delivery';
  }

  return (
    <Page themeId="tool">
      <Header
        title="Release Assistant"
        subtitle="Plan and manage Shift product releases"
      />
      <Content>
        <Box sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 1, sm: 2 }, pb: 2 }}>
          <Box sx={{ mb: 4 }}>
            <Tabs
              value={currentTab}
              onChange={(_event, next) => navigate(`/release-assistant/${next}`)}
              aria-label="Release Assistant sections"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab value="release" label="Release" />
              <Tab value="reports" label="Reports" />
              <Tab value="product-dashboard" label="Product Dashboard" />
              {deliveryEnabled && (
                <Tab value="product-delivery" label="Product Delivery" />
              )}
            </Tabs>
          </Box>

          <QueryClientProvider client={queryClient}>
            <Routes>
              <Route index element={<Navigate to="release" replace />} />
              <Route path="release" element={<ReleasePage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="product-dashboard" element={<ProductDashboardPage />} />
              {deliveryEnabled && (
                <Route path="product-delivery" element={<ProductDeliveryPage />} />
              )}
              <Route path="*" element={<Navigate to="release" replace />} />
            </Routes>
          </QueryClientProvider>
        </Box>
      </Content>
    </Page>
  );
};
